const MenuItems = [
  {
    title: 'Events',
    url: '/events',
  },
  {
    title: 'Members',
    url: '/directory',
  },
  {
    title: 'Deals',
    url: '/deals',
  },
  {
    title: 'Mentors',
    url: '/mentors',
  },
  {
    title: 'Case Studies',
    url: '/stories',
  },
  {
    title: "What's a mastermind?",
    url: '/resources',
  },
  {
    title: 'Join Today',
    url: '/payments',
  },
];

export default MenuItems;
